module.exports = __webpack_public_path__ + "images/homepage-support-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./homepage/images/homepage-support-icon.svg
// module id = 857
// module chunks = 0